
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { WbAccordionItemComponent } from './WbAccordion';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
export default (ComponentInitializeDispatcher as WbAccordionItemComponent).extend({
  name: 'owc-wb-accordion-item',
  components: {
    SlotContainer,
  },
  computed: {
    isDarkMode: function() {
      return Boolean(this.componentData?.darkMode);
    },
  },
});
